import Parse from 'html-react-parser';

function BMP20150(props) {
    let svgCode =
    `<svg width="56" height="76" viewBox="0 0 56 76" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="52" height="34" rx="3" fill="${props.backgroundFill}"/>
        <rect x="2" y="40" width="52" height="34" rx="3" fill="${props.backgroundFill}"/>
        <path d="M18.1213 58.489L18 48L28.6108 58.4272L18.1213 58.489Z" fill="${props.highlightColour}"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M29.714 52.4107C28.2491 52.2736 26.4235 52.8083 24.6696 54.7686L21.6886 52.1014C24.1846 49.3117 27.211 48.1589 30.0867 48.4281C32.9085 48.6922 35.3772 50.3124 36.796 52.646C38.2362 55.0146 38.5732 58.0782 37.2294 61.1313C35.901 64.1493 33.0214 66.9742 28.3689 69.234L26.6213 65.636C30.7189 63.6457 32.7372 61.4081 33.5683 59.5199C34.384 57.6668 34.142 55.9803 33.3782 54.724C32.593 53.4326 31.2327 52.5528 29.714 52.4107Z" fill="${props.highlightColour}"/>
        <path d="M18.1262 20.054L18.0049 9.565L28.6157 19.9922L18.1262 20.054Z" fill="${props.darkFill}"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M29.7188 13.9757C28.254 13.8386 26.4284 14.3733 24.6744 16.3336L21.6934 13.6664C24.1895 10.8768 27.2159 9.72393 30.0916 9.99308C32.9134 10.2572 35.3821 11.8774 36.8009 14.211C38.241 16.5796 38.5781 19.6432 37.2343 22.6963C35.9059 25.7143 33.0263 28.5392 28.3738 30.799L26.6262 27.201C30.7237 25.2107 32.7421 22.9731 33.5732 21.0849C34.3889 19.2318 34.1469 17.5453 33.383 16.289C32.5978 14.9976 31.2375 14.1178 29.7188 13.9757Z" fill="${props.darkFill}"/>
    </svg>`

    props.svgReturn(72, svgCode, "bmp00150", 56, 76);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20150;